import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';
import { initRetryLogger } from '@zg-rentals/satellite-components';
import { analytics } from './analytics';

const builder = new BootstrapBrowserBuilder('satellite-landlord-web', Number(process.env.NEXT_PUBLIC_BUILD_NUMBER))
  .withHostedAppLoggerOptions('rental-manager-api', process.env.NEXT_PUBLIC_LOG_LEVEL)
  .withOnRegister(analytics.initialize);

export const bootstrap = builder.build();

export const appMarkerLogger = bootstrap.logger.child({ appMarker: 'satellite-landlord-web-marker' });

// Initialize the shared retry logger
initRetryLogger(bootstrap.logger.child({ name: 'retryUtils' }));
